import { render, staticRenderFns } from "./AppI18n.global.vue?vue&type=template&id=937ac64c&"
import script from "./AppI18n.global.vue?vue&type=script&lang=js&"
export * from "./AppI18n.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports